import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DealerState } from 'src/app/modules/store/dealer/dealer.reducer';
import * as fromSelectors from './../../../store/dealer/dealer.selectors';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionList } from '../../models/asp.types';
import { unsubscribeSubscriptions } from '../../services/util.service';
import { CertificationStatus, SourceSystem } from '@signal/asp-data-commons';
import { VehicleStatus } from '@signal/asp-data-commons/lib/enums/enum';

@Component({
  selector: 'app-vehicle-delivery',
  templateUrl: './vehicle-delivery.component.html',
  styleUrls: ['./vehicle-delivery.component.scss']
})
export class VehicleDeliveryComponent implements OnInit, OnChanges, OnDestroy {

  @Input() vehicleDetails;
  @Input() showSplitter;
  isUsed:string;
  isNonToyota:boolean;
  isNonLexus:boolean;
  isUVI:boolean;
  isNVI:boolean;
  dealerCode$: Observable<string>;
  dealerCode:string;
  message:string;
  statusMessage:string;
  subscriptions: SubscriptionList = {};
  isLexusDealer = false;
  certification:string;
  arrival:string;
  status:string;
  estimatedDealerArrival:string
  isTestDrive:boolean
  isEditMode:boolean
  isCampaign='';

  constructor(private readonly dealerState: Store<DealerState>,
    private readonly translate: TranslateService)
  {
    this.dealerCode$ = this.dealerState.select(fromSelectors.selectDealerCode); 
    this.subscriptions.dealerSubscription=this.dealerCode$.subscribe(code=>{
      this.dealerCode=code;
      this.isLexusDealer = this.dealerCode?.toString().startsWith('6') ?? false;
     });
  }

  ngOnInit(): void { 
  }

  ngOnChanges(changes: SimpleChanges) {
    const vehicleData = changes.vehicleDetails?.currentValue;
    this.isTestDrive = vehicleData?.isTestDrive
    this.isEditMode = vehicleData?.isEditMode
    if (!!vehicleData) {
    this.isNVI  = vehicleData?.source === SourceSystem.NVI;
    this.isUVI  = vehicleData?.source === SourceSystem.UVI || vehicleData.source === SourceSystem.ME;
    this.status=vehicleData?.dealerCategory;
    this.certification=vehicleData?.certificationStatus;
    this.estimatedDealerArrival=(vehicleData.estimatedDealerArrival==="NA")? 'testDrive.notAvailable' :
    vehicleData.estimatedDealerArrival;
    this.arrival=(this.status===VehicleStatus.A || this.status===VehicleStatus.F)? 'otherTexts.arrivalAtDealer': 'otherTexts.deliveredOn';
    this.isUsed= (this.isNVI) ? 'otherTexts.isNew' :
    (this.isLexusDealer ? 
    (this.certification===CertificationStatus.CERTIFIED ? 
      'otherTexts.lexusCertified' : 'otherTexts.preOwned') :
    (this.certification===CertificationStatus.CERTIFIED ? 
      'otherTexts.toyotaCertified' : 'otherTexts.isUsed')
    );

    this.isNonToyota = !(vehicleData.make?.toUpperCase() === "TOYOTA");
    this.isNonLexus = !(vehicleData.make?.toUpperCase() === "LEXUS");
    if(!vehicleData?.isTestDrive){
    this.message = this.isLexusDealer ? (this.isNonLexus ? 'otherTexts.nonLexus' : '') : (this.isNonToyota ? 'otherTexts.nonToyota' : '');
    }
    this.statusMessage=
    (this.status===VehicleStatus.A ) ? 'otherTexts.allocated' : ( (this.status===VehicleStatus.F) ? ('otherTexts.inTransit') : ('otherTexts.ground') );
    }
    this.isCampaign = vehicleData.isSafetyCampaign ? 'deliveryChecklist.safetyCampaign' : (vehicleData.isNonSafetyCampaign ? 'deliveryChecklist.nonSafetyCampaign' : '');
  }

  ngOnDestroy(){
    unsubscribeSubscriptions(this.subscriptions);
  }

}
